import { MediaQueryProvider } from "context/MediaQueryContext";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import routesConfig from "router";

import reportWebVitals from "./reportWebVitals";
import store from "./store";

const router = createBrowserRouter(routesConfig);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <MediaQueryProvider>
      <RouterProvider router={router} />
    </MediaQueryProvider>
  </Provider>
);

reportWebVitals();
